/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Warehouse_CostInputs */

const en_field_warehouse_cost = /** @type {(inputs: Field_Warehouse_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse`)
};

/**
* | output |
* | --- |
* | "Warehouse" |
*
* @param {Field_Warehouse_CostInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_warehouse_cost = /** @type {((inputs?: Field_Warehouse_CostInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Warehouse_CostInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_warehouse_cost(inputs)
});